import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { UserRole } from '../../constants/roles';

/**
 * DashboardRouter Component
 *
 * Redirects users to their role-specific dashboard:
 * - Trainee → /trainee/home
 * - Admin → /admin/dashboard
 * - Trainer → /trainer/dashboard
 * - Super Admin → /superadmin/dashboard
 */
const DashboardRouter: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) {
      console.log('⚠️ DashboardRouter: No user found, redirecting to login');
      navigate('/login');
      return;
    }

    console.log('🏠 DashboardRouter: Current user role:', user?.role);

    // Redirect based on user role
    switch (user?.role) {
      case UserRole.TRAINEE:
        console.log('🏠 DashboardRouter: Redirecting to Trainee Home Page');
        navigate('/trainee/home', { replace: true });
        break;

      case UserRole.ADMIN:
        console.log('🏠 DashboardRouter: Redirecting to Admin Dashboard');
        navigate('/admin/dashboard', { replace: true });
        break;

      case UserRole.TRAINER:
        console.log('🏠 DashboardRouter: Redirecting to Trainer Dashboard');
        navigate('/trainer/dashboard', { replace: true });
        break;

      case UserRole.SUPER_ADMIN:
        console.log('🏠 DashboardRouter: Redirecting to Super Admin Dashboard');
        navigate('/superadmin/dashboard', { replace: true });
        break;

      default:
        console.log('⚠️ DashboardRouter: Unknown role, redirecting to login');
        navigate('/login');
        break;
    }
  }, [user, navigate]);

  // Show loading state while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'var(--color-background, #ffffff)',
      color: 'var(--color-text-primary, #1f2937)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #e5e7eb',
          borderTopColor: '#FEB901',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ fontSize: '14px' }}>Loading...</p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default DashboardRouter;
